import { call, put, takeEvery } from 'redux-saga/effects'

import { types } from '../../types'
import { getProfilePhoto, getUserProfile, postChangePassword, postUpdateProfile, uploadProfilePhoto } from '../apiRequests/profileRequest'

function* handleGetProfile() {
  try {
    const response = yield call(getUserProfile)
    yield put({
      type: types.GET_PROFILE_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.GET_PROFILE_ERROR,
      error: error.response,
    })
  }
}

function* handleUpdateProfile(action) {
  try {
    const response = yield call(postUpdateProfile, action.params)
    yield put({
      type: types.UPDATE_PROFILE_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.UPDATE_PROFILE_ERROR,
      error: error.response,
    })
  }
}


function* handleChangePassword(action) {
  try {

    const response = yield call(postChangePassword, action.params)
    yield put({
      type: types.CHANGE_PASSWORD_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.CHANGE_PASSWORD_ERROR,
      error: error.response,
    })
  }
}

function* handleUploadProfilePhoto(action) {
  try {
    const response = yield call(uploadProfilePhoto, action.params)
    yield put({
      type: types.UPLOAD_PROFILE_PHOTO_SUCCESS,
      action: response,
    })

  } catch (error) {

    yield put({
      type: types.UPLOAD_PROFILE_PHOTO_ERROR,
      error: error.response,
    })
  }
}

function* handleGetProfilePhoto(action) {
  try {
    const response = yield call(getProfilePhoto, action.userName)
    yield put({
      type: types.GET_PROFILE_PHOTO_SUCCESS,
      action: response,
    })

  } catch (error) {
    yield put({
      type: types.GET_PROFILE_PHOTO_ERROR,
      action: error.response,
    })
  }
}




function* watcherProfilrSaga() {
  yield takeEvery(types.GET_PROFILE_REQUEST, handleGetProfile)
  yield takeEvery(types.UPDATE_PROFILE_REQUEST, handleUpdateProfile)
  yield takeEvery(types.CHANGE_PASSWORD_REQUEST, handleChangePassword)
  yield takeEvery(types.UPLOAD_PROFILE_PHOTO_REQUEST, handleUploadProfilePhoto)
  yield takeEvery(types.GET_PROFILE_PHOTO_REQUEST, handleGetProfilePhoto)

}

export default watcherProfilrSaga
